module.exports = __webpack_public_path__ + "media/images/main_nav_help-701f4b45318431d5d8e8e13198b1f33c.png";